import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { SxProps, Theme } from "@mui/material/styles";
import { CustomFields } from "../../../api";

const DEFAULT_STAFF_TYPES: CustomFields[] = [
  CustomFields.ASSIGNED_PARALEGAL,
  CustomFields.RESPONSIBLE_ATTORNEY,
  CustomFields.SUPPORTING_ATTY,
  CustomFields.SENIOR_MANAGING_ATTY,
  CustomFields.LEGAL_ASSISTANT,
];

const STAFF_TYPE_LABELS: Partial<Record<CustomFields, string>> = {
  [CustomFields.ASSIGNED_PARALEGAL]: "AP",
  [CustomFields.RESPONSIBLE_ATTORNEY]: "RAA",
  [CustomFields.SUPPORTING_ATTY]: "SA",
  [CustomFields.SENIOR_MANAGING_ATTY]: "SMA",
  [CustomFields.LEGAL_ASSISTANT]: "ALA",
};

type ClioStaffTypeSelectProps = {
  value?: string | null;
  onChange: (value: string | null) => void;
  options?: CustomFields[];
  label?: string;
  size?: "small" | "medium";
  fullWidth?: boolean;
  required?: boolean;
  sx?: SxProps<Theme>;
  /** Show short role labels (RAA, AP, …) instead of enum values. */
  useShortLabels?: boolean;
};

export default function ClioStaffTypeSelect({
  value,
  onChange,
  options = DEFAULT_STAFF_TYPES,
  label = "Select Staff Type",
  size = "small",
  fullWidth = true,
  required = false,
  sx,
  useShortLabels = false,
}: ClioStaffTypeSelectProps) {
  const handleChange = (event: SelectChangeEvent) => {
    const next = event.target.value;
    onChange(next || null);
  };

  return (
    <FormControl size={size} fullWidth={fullWidth} required={required} sx={sx}>
      <InputLabel id="clio-staff-type-label">{label}</InputLabel>
      <Select
        labelId="clio-staff-type-label"
        label={label}
        value={value ?? ""}
        onChange={handleChange}
      >
        {options.map((type) => (
          <MenuItem key={type} value={type}>
            {useShortLabels ? STAFF_TYPE_LABELS[type] ?? type : type}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
